import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, TextField, Paper, withStyles, Button, FormHelperText, Select, MenuItem } from '@material-ui/core';
import PageTitle from '../../components/PageTitle/PageTitle';
import FormInputLabel from '../../components/FormInputLabelView';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../utils/common';
import { tenantInfo } from '../../utils/tenantInformation';

class ModulesPage extends React.Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this); // i think you are missing this
    this.state = {
      tenants: [],
      data: {
        id: null,
        name: '',
        tenantId: null,
        mapId: null,
        description: '',
        type: 'hospital',
      },
      errorField: {
        name: false,
        tenantId: false,
        mapId: false,
      },
    };
  }

  async componentDidMount() {
    const tenants = tenantInfo();
    this.setState({ tenants });

    const { offset, limit, search, sort, order, tenantIds } = this.props.subGroup.toJS();
    await this.props.subGroup.getSubGroup(offset, limit, search, sort, order, tenantIds);

    this.initData();

    if (this.state.data.tenantId) {
      await this.props.maps.getMapByTenantId(this.state.data.tenantId);
    }
  }

  goBack() {
    this.props.subGroup.setAction('action', true);
    this.props.history.goBack();
  }

  initData() {
    const { subGroups, tenantIds } = this.props.subGroup.toJS();
    const serialPath = this.props.location.pathname.replace('/app/modules/', '');
    const editId = Number(serialPath.replace('/edit', ''));
    const viewId = Number(serialPath.replace('/view', ''));

    const showData = subGroups.data.find((item) => item.id === (editId || viewId));
    if (showData) {
      this.setState({
        data: {
          id: showData.id,
          name: showData.name,
          tenantId: showData.tenantId,
          mapId: showData.map ? showData.map.id : null,
          type: showData.type ? showData.type : 'hospital',
          description: showData.description,
        },
      });
    } else {
      const tenants = tenantInfo();
      if (tenants.length === 1) {
        tenants.forEach((g) => {
          this.setState({ data: { tenantId: g.id } });
        });
      } else if (tenantIds && tenantIds.length === 1) {
        tenantIds.forEach((id) => {
          this.setState({ data: { tenantId: id } });
        });
      }
    }
  }

  handleChange = async (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState((prevState) => {
      prevState.data[name] = value;
      return prevState;
    });
    if (name === 'tenantId') {
      await this.props.maps.getMapByTenantId(value);
      this.setState({
        ...this.state,
        data: {
          ...this.state.data,
          mapId: null,
        },
      });
    }
  };

  handleCreateSubGroup = async (data) => {
    const { t } = this.props;
    if (this.validate()) {
      try {
        const result = await this.props.subGroup.createSubGroup(data);
        if (result.statusCode === 200) {
          Swal.fire({
            html: `<h4>${t('create_success')}`,
            type: 'success',
          }).then(async (resultSuccess) => {
            if (resultSuccess.value) {
              this.props.history.push('../modules');
            }
          });
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
        }
      }
    }
  };

  handleEditSubGroup(data) {
    const { t } = this.props;
    if (this.validate()) {
      Swal.fire({
        html: `<h4>${t('edit_module')}`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: `${t('edit')}`,
        cancelButtonText: `${t('cancel')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          try {
            const result = await this.props.subGroup.updateSubGroup(data);
            if (result.statusCode === 200) {
              Swal.fire({
                html: `<h4>${t('update_success')}`,
                type: 'success',
              }).then(async (resultSuccess) => {
                if (resultSuccess.value) {
                  this.props.subGroup.setAction('action', true);
                  this.props.history.push('../../modules');
                }
              });
            } else {
              Swal.fire({
                html: `<h4>${t('failed_to_update')}`,
                type: 'error',
              });
            }
          } catch (e) {
            if (e.statusCode === 401) {
              clearLocalStorage();
              window.location.href = '/login';
            } else {
              Swal.fire({
                html: `<h4>${t('failed_to_update')}`,
                type: 'error',
              });
            }
          }
          // if (result) {
          //   Swal.fire({html: "<h4>แก้ไขสำเร็จ!<br/>ข้อมูลนี้ได้ถูกแก้ไขสำเร็จแล้ว",type: "success"});
          // } else {
          //   Swal.fire({html: "<h4>แก้ไขไม่สำเร็จ<br/>ข้อมูลนี้ยังไม่ถูกแก้ไข",type: "error"});
          // }
        }
        // else if (result.dismiss === Swal.DismissReason.cancel) {
        //   Swal.fire({ html: "<h4>ยกเลิก<br/>ข้อมูลนี้จะยังไม่ถูกแก้ไข :)", type: "error" });
        // }
      });
    }
  }

  validate() {
    const { data } = this.state;
    if (!data.name || !data.tenantId) {
      let checkName = !data.name ? true : false;
      let checkTenantId = !data.tenantId ? true : false;
      this.setState({
        errorField: {
          name: checkName,
          tenantId: checkTenantId,
        },
      });
      return false;
    } else {
      this.setState({
        errorField: {
          name: false,
          tenantId: false,
          mapId: false,
        },
      });
    }
    return true;
  }

  clearErrorField(key) {
    if (key === 'name') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          name: false,
        },
      });
    }
    if (key === 'tenantId') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          tenantId: false,
        },
      });
    }
  }

  renderFormCreate() {
    const { classes, t } = this.props;
    const { data, tenants } = this.state;
    const { mapsInfo } = this.props.maps.toJS();

    return (
      <React.Fragment>
        {/* <Loader loading={loading} /> */}
        <Paper className={classes.paper}>
          <PageTitle title={t('create_a_module')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.tenantId || ' '}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                >
                  <MenuItem fullwidth='true' key={9999999} value={' '}>
                    {t('please_select_tenant')}
                  </MenuItem>
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.tenantId : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('map')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.mapId || ' '}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'mapId',
                    id: 'mapId',
                  }}
                >
                  <MenuItem fullwidth='true' key={9999999} value={' '}>
                    {t('please_select_map')}
                  </MenuItem>
                  {(mapsInfo || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('type')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.type || 'hospital'}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'type',
                    id: 'type',
                  }}
                >
                  <MenuItem value='hospital'>{t('hospital')}</MenuItem>
                  <MenuItem value='home'>{t('home')}</MenuItem>
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleCreateSubGroup(data)}
                  className={classes.button}
                >
                  {t('create')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderFormEdit() {
    const { classes, t } = this.props;
    const { data, tenants } = this.state;
    const { mapsInfo } = this.props.maps.toJS();
    return (
      <React.Fragment>
        {/* <Loader loading={loading || group.loading} /> */}
        <Paper className={classes.paper}>
          <PageTitle title={t('edit_a_module')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.tenantId || ' '}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                  disabled
                >
                  <MenuItem fullwidth='true' key={9999999} value={' '}>
                    {t('please_select_tenant')}
                  </MenuItem>
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('map')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.mapId || ''}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'mapId',
                    id: 'mapId',
                  }}
                >
                  <MenuItem fullwidth='true' key={9999999} value={''}>
                    {t('please_select_map')}
                  </MenuItem>
                  {(mapsInfo || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('type')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.type || 'hospital'}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'type',
                    id: 'type',
                  }}
                >
                  <MenuItem value='hospital'>{t('hospital')}</MenuItem>
                  <MenuItem value='home'>{t('home')}</MenuItem>
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleEditSubGroup(data)}
                  className={classes.button}
                >
                  {t('edit')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderView() {
    const { classes, t } = this.props;
    const { data, tenants } = this.state;
    const { mapsInfo } = this.props.maps.toJS();

    return (
      <React.Fragment>
        {/* <Loader loading={subGroup.loading} /> */}
        <Paper className={classes.paper}>
          <PageTitle title={t('view_a_module')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('group')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.tenantId == null ? '' : data.tenantId}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                  disabled
                >
                  <MenuItem fullwidth='true' key={9999999} value={' '}>
                    {t('please_select_tenant')}
                  </MenuItem>
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                variant='outlined'
                margin='dense'
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('map')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.mapId == null ? '' : data.mapId}
                  inputProps={{
                    name: 'mapId',
                    id: 'mapId',
                  }}
                  disabled
                >
                  {(mapsInfo || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('type')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.type || 'hospital'}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'type',
                    id: 'type',
                  }}
                  disabled
                >
                  <MenuItem value='hospital'>{t('hospital')}</MenuItem>
                  <MenuItem value='home'>{t('home')}</MenuItem>
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description}
                variant='outlined'
                margin='dense'
                disabled
              />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <div className={classes.buttons}>
              <Button className={classes.button} onClick={this.goBack}>
                {t('back')}
              </Button>
            </div>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  render() {
    const path = this.props.match.path.replace('/app/modules/:id/', '');
    let result;
    switch (path) {
      case 'edit':
        result = this.renderFormEdit();
        break;
      case 'view':
        result = this.renderView();
        break;
      default:
        result = this.renderFormCreate();
        break;
    }
    return result;
  }
}

const styles = (theme) => ({
  spaceTop: {
    marginTop: '10px',
  },
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: 20,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  formControl: {
    width: '100%',
  },
  TitlePage: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 4,
    background: '#049588',
    height: '90px',
    margin: '-24px',
  },
  typo: {
    color: 'white',
    padding: '30px',
  },
});
export const page = inject('subGroup', 'maps', 'bed', 'group')(observer(ModulesPage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
